import * as Types from 'src/actions/project/get-document-image/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';

export interface GetDocumentImageAttempt extends Action {
  type: Types.GET_DOCUMENT_IMAGE_ATTEMPT;
  payload: number;
}

export interface GetDocumentImageSuccess extends Action {
  type: Types.GET_DOCUMENT_IMAGE_SUCCESS;
  payload: { image: File, documentId: number };
}

export interface GetDocumentImageFailure extends Action {
  type: Types.GET_DOCUMENT_IMAGE_FAILURE;
  payload: number;
}

export type GetDocumentImageAction = GetDocumentImageAttempt | GetDocumentImageSuccess | GetDocumentImageFailure | File;

export interface GetDocumentImageThunk extends ThunkAction<Promise<GetDocumentImageAction>, RootState, undefined> {
}

export const getDocumentImageAttempt: ActionCreator<GetDocumentImageAttempt> = (documentId: number) => ({
  type: Types.GET_DOCUMENT_IMAGE_ATTEMPT,
  payload: documentId
});

export const getDocumentImageSuccess: ActionCreator<GetDocumentImageSuccess> = (
  payload: { image: File, documentId: number }
) => ({
  type: Types.GET_DOCUMENT_IMAGE_SUCCESS,
  payload: payload,
});

export const getDocumentImageFailure: ActionCreator<GetDocumentImageFailure> = (documentId: number) => ({
  type: Types.GET_DOCUMENT_IMAGE_FAILURE,
  payload: documentId
});

export const getDocumentImage: ActionCreator<GetDocumentImageThunk> = (
  documentId: number, imageUrl: string
): GetDocumentImageThunk => {

  return (dispatch: Dispatch<RootState>): Promise<GetDocumentImageAction> => {
    dispatch(getDocumentImageAttempt(documentId));

    return ApiClient.file.get(imageUrl)
      .then((response: AxiosResponse<File>): File => {

        const image: File = response.data;

        dispatch(getDocumentImageSuccess({image: image, documentId: documentId}));
        return image;
      }).catch((e: {}): GetDocumentImageFailure => {
        return dispatch(getDocumentImageFailure(documentId));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/project/get-document-image/GetDocumentImage.actions.tsx